/* Creator Privacy Mode. One module-level flag so every money formatter can ask
   "should I mask this?" without prop-drilling. Pages call usePrivacy() so they
   re-render when the flag flips. */
import { useEffect, useState } from 'react';

const API = process.env.REACT_APP_BACKEND_URL;
const KEY = 'pr_privacy_mode';

export const MASK = '$•••';

let on = (() => {
  try { return localStorage.getItem(KEY) === '1'; } catch { return false; }
})();

const subs = new Set();

export const isPrivate = () => on;
export const mask = (formatted) => (on ? MASK : formatted);

export const subscribePrivacy = (fn) => {
  subs.add(fn);
  return () => subs.delete(fn);
};

export const setPrivacy = (value, { persist = true } = {}) => {
  on = !!value;
  try { localStorage.setItem(KEY, on ? '1' : '0'); } catch { /* private browsing */ }
  subs.forEach((fn) => fn(on));
  if (persist) {
    fetch(`${API}/api/settings/preferences`, {
      method: 'PUT',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ privacy_mode: on }),
    }).catch(() => {});
  }
};

export const togglePrivacy = () => setPrivacy(!on);

export const usePrivacy = () => {
  const [value, setValue] = useState(on);
  useEffect(() => subscribePrivacy(setValue), []);
  return value;
};

/* Pull the saved choice on app load so it follows the account across devices. */
export const hydratePrivacyFromServer = async () => {
  try {
    const res = await fetch(`${API}/api/settings/preferences`, { credentials: 'include' });
    if (!res.ok) return;
    const d = await res.json();
    if (!!d.privacy_mode !== on) setPrivacy(!!d.privacy_mode, { persist: false });
  } catch { /* offline, keep the local choice */ }
};
